import { RetailLocationFilters } from '../locations/Filters';
import { getOpenStatus } from '../locations/utils/workHours';

/** @param {FF.Location__LDP} location */
export const getRetailerName = location => {
  if (location.type !== 'WHOLESALE') {
    return null;
  }

  const matchedFilter = Array.from(RetailLocationFilters).find(filterItem => {
    const [, filterData] = filterItem;
    const { title, testFn } = filterData;
    if (!title || !testFn) {
      return false;
    }

    return testFn(location);
  });

  if (!matchedFilter) {
    return null;
  }

  return matchedFilter[1].title;
};

/** @param {FF.Location__LDP} locationData */
export function getLocationAttributesForSegment(locationData) {
  if (locationData.type === 'FRIDGE') {
    const { isOpenNow = false } =
      (locationData.locationConfigs.workHours &&
        locationData.locationConfigs.timeZone &&
        getOpenStatus(
          JSON.parse(locationData.locationConfigs.workHours),
          locationData.locationConfigs.timeZone,
        )) ||
      {};
    return {
      fridge_id: locationData.fridgeId,
      is_public: locationData.locationConfigs.accessTo === 'PUBLIC',
      is_open: isOpenNow,
      ordering_enabled: locationData.locationConfigs.reserve === 1,
      pricing_schema: locationData.locationConfigs.pricingSchema,
    };
  }
  if (locationData.type === 'WHOLESALE') {
    return {
      retail_id: locationData.retailId,
    };
  }

  throw new Error('unexpected location');
}
